import React from 'react';

import { useState } from 'react';

import * as yup from 'yup';

import { Button, Form, Row, Modal } from 'react-bootstrap';

import Alert from '../Alert';

import ModalCloseButton from '../Modal/ModalCloseButton';

const schema = yup.object().shape({
});

const VerifyContactpersonModal = ({ modal, setModal, person, verifyPerson, rejectPerson, contactLabel, message }) => {
    const [btnLabel, setBtnLabel] = useState("Erweitertes Führungszeugnis herunterladen");

    const closeModal = () => {
        setModal(false);
    }

    const rejectVerification = () => {
        rejectPerson();
    }

    return (
        <Modal centered show={modal} onHide={closeModal}>
            <Modal.Header>
                <Modal.Title>{contactLabel} verifizieren</Modal.Title>
                <ModalCloseButton onClick={closeModal} />
            </Modal.Header>
            <Modal.Body>
                {message && <Alert type="error" message={message} />}
                    <Form.Group as={Row} className="mb-3" controlId="criminalRecord">
                        <Button className="btn-block" href={"/Operator/DownloadCriminalRecord?ContactPersonID=" + person.ContactPersonID} variant="light">{btnLabel}</Button>
                    </Form.Group>                   
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={closeModal}>
                    Abbrechen
                </Button>
                <Button variant="danger" onClick={rejectVerification}>
                    Ablehnen
                </Button>
                <Button variant="success" onClick={() => verifyPerson(person.ContactPersonID)}>
                    Verifizieren
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

export default VerifyContactpersonModal;